// @flow

import _ from 'lodash';

import { ValidatableMixin } from 'validatable';
import { JuridicalPerson as JuridicalPersonBase } from 'person-model';
import vb from 'validation-builder';
import kv from 'rgs-knockout-validation';
import stringify from 'json-stable-stringify';
import ObservableMap from 'observable-map';

// myrgs-user-person-model
import type { MyRgsUserPersonOptions } from './myrgs-user-person-model.flow';
import { JuridicalExtendedAddress } from 'myrgs-user-person-model/juridical-extended-address';
import { OPFS_IP } from 'known-opf';

export class MyRgsUserJuridicalPerson extends ValidatableMixin(JuridicalPersonBase) {
	constructor (options: MyRgsUserPersonOptions, model, ...args) {

		options = _.defaultsDeep({}, options, {
			dictionaries: {
				kladr: {
					houses: new ObservableMap({ hash: (v) => stringify(v) }),
					streets: new ObservableMap({ hash: (v) => stringify(v) }),
					settlements: new ObservableMap({ hash: (v) => stringify(v) }),
					settlementsRsa: new ObservableMap(),
				},
				businessEntityTypes: new ObservableMap(),
				jpIdentityDocumentTypes: new ObservableMap(),
			},
		});

		super(options, model, ...args);

		this._model = model;

		this.BusinessEntityTypeID.extend({
			validation: vb.all([
				vb.required(),
			]),
		});

		this.Name.extend({
			required: true,
			validation: vb.all([
				vb.minLength(10),
				vb.maxLength(1000),
				vb.consecutiveCharRepetitionLimit(3),
				vb.juridicalOrganizationName(),
			]),
		});

		this.Phone.extend({
			validation: vb.all([
				vb.required(),
				vb.phone11Digits(),
			]),
		});

		this.INN.extend({
			validation: vb.all([
				vb.required(),
				vb.ternary(() => this.isIp(),
					vb.all([
						vb.ipInn(),
					]),
					vb.all([
						vb.inn(),
					]),
				),
			]),
		});
	}

	_newAddress (options, ...rest) {
		return new JuridicalExtendedAddress(options, ...rest);
	}

	isIp () {
		return this.BusinessEntityTypeID() === OPFS_IP;
	}

	validationArray () {
		return this.IdentityDocument.validationArray()
			.concat(_.filter(this, kv.utils.isValidatable))
			.concat(this.Registration.validationArray());
	}
}
